import { cn } from '@/lib/utils'
import { colors } from '@/lib/tokens'

function Card({
  children,
  className,
  style,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      className={cn('rounded-lg', className)}
      style={{
        background: colors.bgBase,
        border: `1px solid ${colors.borderDefault}`,
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  )
}

export { Card }
